module.exports = __webpack_public_path__ + "static/media/2.24_preview.a3493791.png";